import { Suspense } from "react";
import { createHashRouter } from "react-router-dom";
import MobileLayout from "../../layouts/Mobile";
import { routes } from "./routes";
import { PageSizeLoader } from "../../components/CustomComponents/PageSizeLoader";
import { AppErrorBoundary } from "../../components/CustomComponents/PageErrorBoundry";
import { ErrorComponent } from "../../components/CustomComponents/PageErrorBoundry/ErrorComponent";
import { Spin } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import { HomeHealthRouteGuard } from "./HomeHealthRouteGuard";

// Module-level singleton — created once, never recreated.
// Previously this was a function called with `connectionStatus` on every render,
// which caused `createHashRouter` to run on every network-state change, producing
// a new RouterProvider that unmounted the entire app and reset all component state.
// ErrorComponent now reads connectionStatus from Redux directly.
export const mobileRouter = createHashRouter(
  [
    {
      path: "/",
      element: <MobileLayout />,
      children: Object.entries(routes).map(([_, route]) => ({
        ...route,
        element: (
          <AppErrorBoundary
            FallbackComponent={({ error, resetErrorBoundary }) => (
              <ErrorComponent
                error={error}
                resetErrorBoundary={resetErrorBoundary}
              />
            )}
            resetKeys={[route.path]}
          >
            <Suspense
              fallback={
                <PageSizeLoader
                  loader={
                    <Spin
                      indicator={
                        <LoadingOutlined
                          style={{ fontSize: 48, color: "#161646" }}
                          spin
                        />
                      }
                    />
                  }
                />
              }
            >
              <HomeHealthRouteGuard>
                <route.element />
              </HomeHealthRouteGuard>
            </Suspense>
          </AppErrorBoundary>
        ),
      })),
    },
  ],
  {
    future: {
      v7_startTransition: true,
    },
  }
);
